import React from 'react';
import "./publicationCard.scss";

const PublicationCard = ({props}) => {

    const {title, lang_code, cover, publication_title, sub_title, excerpt, intro, body, full_url } = props;

    return(
        <div className="publication-item publication-post border-top-black-25 py-m">
            <div className="d-flex flex-row">
                <div className="card-body d-flex flex-column justify-content-between pr-g">
                    <div className="">
                        <a href={`${full_url}`}><h5 className="color-black-75 has-lines-1">{title}</h5></a>
                            {publication_title && <p className="fw-medium fs-s has-lines-1">{publication_title}</p> ||
                                sub_title && <p className="fw-medium fs-s has-lines-1">{sub_title}</p> ||
                            <p className="fw-medium fs-s has-lines-1">Overview</p>}
                        <div className="content">
                            {excerpt && <p className="has-lines-3">{excerpt}</p> ||
                            intro && <p className="has-lines-3">{intro}</p> ||
                            body && <p className="has-lines-3">{body}</p>}
                        </div>
                    </div>
                </div>
                <a href={`${full_url}`} className="d-inline-block">
                    <img src={cover} alt="" className="card-img col-3" style={{width: "150px"}}/>
                </a>
            </div>
        </div>
    )
}

export default PublicationCard;
